import Layouts from './style';

export const ShopLayout = Layouts.ShopLayout;
export const CheckoutLayout = Layouts.CheckoutLayout;
export const OrderLayout = Layouts.OrderLayout;



// WEBPACK FOOTER //
// ../shop_main/components/layout/index.js